import { observer } from 'mobx-react-lite'
import { Row, Col, InputNumber, Button, Divider } from 'antd'
import i from '../../../../translations/i'
import { __product } from '../__product'
import { runInAction } from 'mobx'
import price_types_controller from '../../../settings/price_types/controller'
import React, { useEffect, useState } from "react";
import { ClearOutlined } from "@ant-design/icons";

export const ProductPrice = observer(() => {

  useEffect(() => {
    // price_types_controller.get()
  }, [])

  return(
    <>
      <Row gutter={[20, 20]} align="bottom">
        <Col span={24}>
          <Row gutter={[20, 20]}>
            {price_types_controller.items.map((el: any, index: number) => (
              <Col span={24}>
                <Row justify="space-between" align="bottom" gutter={[20, 20]}>
                  <Col span={6}>
                    <label className="formLabel">{i.t('product:priceType')}</label>
                    <p>{el.name ?? el.private_name}</p>
                  </Col>
                  <Col span={6}>
                    <label className="formLabel">{i.t('product:oldPrice')}</label>
                    <InputNumber
                      style={{ width: '100%' }}
                      value={(__product.item.prices.find((e: any) => e.price_type_id === el.id)?.old_price) || 0}
                      onChange={(value: any) => __product.setPrice(el.id, 'old_price', value)}
                    />
                  </Col>
                  <Col span={6}>
                    <label className="formLabel">{i.t('product:finalPrice')}</label>
                    <InputNumber
                      style={{ width: '100%' }}
                      value={(__product.item.prices.find((e: any) => e.price_type_id === el.id)?.price) || 0}
                      onChange={(value: any) => __product.setPrice(el.id, 'price', value)}
                    />
                  </Col>
                </Row>
                <Divider />
              </Col>
            ))}
          </Row>
        </Col>
      </Row>
    </>
  )
})